export default __webpack_public_path__ + "static/media/yellow-band-medium.f8906d6b.svg";